import { render, staticRenderFns } from "./mob-pure.vue?vue&type=template&id=6dcab18f&scoped=true"
import script from "./mob-pure.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-pure.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-pure.vue?vue&type=style&index=0&id=6dcab18f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcab18f",
  null
  
)

export default component.exports